module.exports = __webpack_public_path__ + "img/wendangguanlihoutai.698ed28c.png";